export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10766.1d5883ec.jpg";